/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 24px 32px;

  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
  }

  .content-tabs {
    background: #fff;
    margin-top: 20px;
    padding: 20px;
    border-radius: 8px;
  }

  .content-tabs .ant-tabs-tab {
    padding: 12px 20px;
  }

  .table-filter {
    margin: 10px 20px 10px 0;
  }
  .table-search {
    max-width: 50%;
  }
`;

